<mat-form-field class="ai-tag-field" appearance="outline">
  <mat-label>{{ label }}</mat-label>
  <mat-chip-grid #chipGrid>
    @for (tag of selected; track tag) {
    <mat-chip-row (removed)="remove(tag)">
      {{ tag }}
      <button matChipRemove><mat-icon>cancel</mat-icon></button>
    </mat-chip-row>
    }
    <input
      #tagInput
      placeholder="Search tags..."
      [matChipInputFor]="chipGrid"
      [matChipInputSeparatorKeyCodes]="separatorKeys"
      [matAutocomplete]="auto"
      [formControl]="searchControl"
      (focus)="onFocus()"
      (matChipInputTokenEnd)="addOption($event)"
    />
  </mat-chip-grid>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onTagSelected($event)">
    @for (tag of filtered; track tag) {
    <mat-option [value]="tag">{{ tag }}</mat-option>
    }
    @if (filtered.length === 0) {
    <mat-option disabled>No matching tags</mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
